import { RegisterLayout } from "../../layouts/RegisterLayout";
import { RegisterMultiStepForm } from "../../components/auth/RegisterMultiStepForm";
import { RegisterSteps } from "../../config/RegisterSteps";
import MainStyle from "../../style/Main.module.css";
import images from "../../utils/images";
import { useRegister } from "../../hooks/useAuth";
import { isAuthenticated } from "../../utils/authenticated";
import { Navigate } from "react-router-dom";

export const RegisterPage = () => {
  const {
    currentStep,
    formData,
    stepErrors,
    setStepErrors,
    isSubmitting,
    handleChange,
    nextStep,
    prevStep,
    // submit
  } = useRegister({
    steps: RegisterSteps,
  });

  // const handleFinalSubmit = async () => {
  //   await submit();
  //   navigate('/onboarding');
  // };
  if (isAuthenticated()) {
    return <Navigate to="/homepage" />;
  }
  return (
    <RegisterLayout>
      <div className={MainStyle.logoview}>
        <img src={images.logoimg} alt="Company Logo" />
      </div>

      <RegisterMultiStepForm
        steps={RegisterSteps}
        currentStep={currentStep}
        formData={formData}
        errors={stepErrors}
        setStepErrors={setStepErrors}
        isSubmitting={isSubmitting}
        onChange={handleChange}
        onNext={nextStep}
        onBack={prevStep}
        // onSubmit={handleFinalSubmit}
      />
    </RegisterLayout>
  );
};
